import React from 'react';

export function Testimonials() {
  const reviews = [
    {
      name: 'Dr. Poonam',
      rating: 5,
      text: "Today I tried Kiane Classic in breakfast. It is perfect breakfast option for busy mornings — nutritious, tasty and ready in minutes. Thank you for providing such a wonderful product 😍",
      tag: 'Classic',
      accent: 'amber',
    },
    {
      name: 'Jaskeerat',
      rating: 5,
      text: "Kiane Classic oats breakfast is tasty and really good. Easy to prepare and completes everyday morning nutrition needs. It's very handy and healthy option for any working person who doesn't have much time to prepare breakfast in the morning. Thank you! ☺️",
      tag: 'Classic',
      accent: 'green',
    },
    {
      name: 'Mridulika',
      rating: 5,
      text: "I happened to come across KIANE by chance while walking through the market, and something about it instantly called me. It didn't feel like ordinary muesli — it felt like oats reimagined: fresh, wholesome, flavorful, and made with care. Being homemade makes it even more special. A beautiful creation — truly a little bowl of goodness.",
      tag: 'Classic',
      accent: 'coral',
    },
    {
      name: 'Vipul',
      rating: 5,
      text: "Perfect for my busy mornings. I used to skip breakfast entirely but Kiane has changed that. No cooking, no mess, just nutrition in a bowl. Highly recommend to anyone with a hectic schedule.",
      tag: 'Choco Delight',
      accent: 'green',
    },
  ];

  return (
    <section id="testimonials" className="section testimonials-section">
      <div className="container">
        <h2>What Our Customers Say</h2>
        <p className="section-intro">
          Real people, real mornings. Here's what the Kiane community has to say.
        </p>
        <div className="testimonials-grid">
          {reviews.map((r) => (
            <div className={`testimonial-card testimonial-card-${r.accent}`} key={r.name}>
              <div className="testimonial-top">
                <div className="testimonial-stars">{'★'.repeat(r.rating)}</div>
                <span className="testimonial-tag">{r.tag}</span>
              </div>
              <p className="testimonial-text">"{r.text}"</p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">{r.name.charAt(0)}</div>
                <div>
                  <p className="testimonial-name">{r.name}</p>
                  <p className="testimonial-location">✅ Verified Buyer</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
